import { type LoaderFunctionArgs } from 'react-router-dom';
import { type OrganizationDto } from '@src/api/api.types.ts';
import organizationService from '@src/api/services/OrganizationService.ts';

export type OrganizationDetailsLoaderData = OrganizationDto;

export const organizationDetailsViewLoader = async ({
  params,
}: LoaderFunctionArgs) => {
  const organizationId = params.organizationId;
  if (!organizationId) {
    throw new Error('Organization ID is required');
  }

  return await organizationService.getOrganizationById(organizationId);
};
